module.exports = __webpack_public_path__ + "img/pencil404.3abb123c.png";